import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IAuthProvider } from '../providers/auth-provider.interface';
import { LogtoAuthService } from './logto-auth.service';

/**
 * Main Auth Service (Facade Pattern)
 * This service abstracts the underlying auth provider
 * Makes it easy to switch between different auth providers
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
    private provider: IAuthProvider = inject(LogtoAuthService);

    /**
     * Observable stream of authentication status
     */
    public isAuthenticated$ = this.provider.isAuthenticated$;

    /**
     * Observable stream of user data
     */
    public userData$ = this.provider.userData$;

    /**
     * Observable stream of access token
     */
    public accessToken$ = this.provider.accessToken$;

    /**
     * Initiate sign-in flow
     */
    signIn(): void {
        this.provider.signIn();
    }

    /**
     * Sign out current user
     */
    signOut(): Observable<unknown> {
        return this.provider.signOut();
    }
}
